import { render, staticRenderFns } from "./relationdepartment.vue?vue&type=template&id=47d1808f&scoped=true&"
import script from "./relationdepartment.vue?vue&type=script&lang=js&"
export * from "./relationdepartment.vue?vue&type=script&lang=js&"
import style0 from "./relationdepartment.vue?vue&type=style&index=0&id=47d1808f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d1808f",
  null
  
)

export default component.exports